import { useQuery } from '@tanstack/react-query';
import { formBuilderApi, formBuilderKeys } from '@/features/quote-and-apply-builder';

export function useCarrierSummaries() {
  return useQuery({
    queryKey: formBuilderKeys.lists(),
    queryFn: formBuilderApi.getCarrierSummaries,
  });
}
